import React from "react";
import ConfigSection from "../../ConfigSection";

const SubVendorCategorySelection = ({ userDetails, selectedClient }) => {
  return (
    <ConfigSection
      title='Sub Vendor Category'
      configType='SubVendorCategory'
      userDetails={userDetails}
      selectedClient={selectedClient}
      configKey='title'
    />
  );
};

export default SubVendorCategorySelection;
